import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Shipper } from '../models/shipper.model';
import { ResponseData } from '../models/helpers.model';
import { FilterOptions } from '../models/filter.model';

@Injectable({
  providedIn: 'root',
})
export class ShipperService {
  constructor(private http: HttpClient) {}

  getShippers(filterOptions: FilterOptions): Observable<ResponseData<Shipper>> {
    return this.http.post<ResponseData<Shipper>>(
      '/shippers/filter',
      filterOptions
    );
  }

  getShipper(id: string): Observable<Shipper> {
    return this.http.get<Shipper>(`/shippers/${id}`);
  }

  updateShipper(id: string, data: Partial<Shipper>): Observable<string> {
    return this.http.put<string>(`/shippers/${id}`, data, {
      responseType: 'text' as 'json',
    });
  }

  deleteShipper(id: string): Observable<string> {
    return this.http.delete<string>(`/shippers/${id}`, {
      responseType: 'text' as 'json',
    });
  }

  addShipper(data: Partial<Shipper>): Observable<Shipper> {
    return this.http.post<Shipper>('/shippers', data);
  }
}
